module.exports = __webpack_public_path__ + "static/Angeliques-Beauty-Salon-Feb-Santa-Clara-County-e860ec27d33c82468bdbae7a54bcab64.jpg";